export enum AirComponentType {
  Score = 'score',
  Temperature = 'temp',
  Humidity = 'humid',
  CO2 = 'co2',
  Chemicals = 'voc',
  Dust = 'dust',
  PM25 = 'pm25'
}
